"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgMarkerPin02 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 10a9 9 0 0 1 18 0c0 3.12-1.744 5.366-3.529 7.224-.43.449-.875.886-1.304 1.308l-.056.055c-.45.443-.884.87-1.292 1.3-.82.866-1.49 1.692-1.925 2.56a1 1 0 0 1-1.788 0c-.434-.868-1.104-1.694-1.925-2.56-.408-.43-.842-.857-1.292-1.3l-.056-.055c-.43-.422-.874-.859-1.304-1.308C4.744 15.366 3 13.12 3 10Zm12-.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z", fill: "currentColor" }) }))); };
exports.default = SvgMarkerPin02;
